import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import styled from "styled-components";
import { UserAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import LoaderGif from "../../assets/images/ie_loader.gif";

const CheckoutContainer = styled.div`
  min-height: 200px;
  border: solid lightgrey 1px;
  margin-top: 1rem;
  margin-left: 2rem;
`;

function OrderNoteCard({
  onSubmitNote,
  onChangeOrderNote,
  order_note,
  mainHeading,
}) {
  const [count, setCount] = useState(255);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(UserAction.getAddressReq());
  }, []);
  const address = useSelector((store) => store.UserReducer.addresses);
  const addressOption = address.map((item) => {
    return { label: item.address, value: item.id };
  });
  const isLoader = useSelector((store) => store?.UserReducer?.isUpdateOrder);

  return (
    <Row>
      <Col span={24} style={{ marginTop: "2.2rem" }}>
        <Row justify="center">
          <Col span={22}>
            <h2 className="text-left checkout-heading">{mainHeading}</h2>
          </Col>
        </Row>
        <CheckoutContainer>
          <Row justify="center" style={{ marginTop: "1rem" }}>
            <Col span={22}>
              <h2 className="text-left">Additional Notes</h2>{" "}
            </Col>
            <Col span={22} style={{ marginTop: "1rem" }}>
              {/* <TextInput
                    label="Basemix Description"
                    name="description"
                    onChange={(description) =>
                      setAddBasemix({
                        ...addBasemix,
                        description: description.target.value,
                      })
                    }
                    required
                    value={addBasemix.description}
                  /> */}
              <TextField
                name="description"
                placeholder="Add Order Notes (if any).."
                multiline
                rows={4}
                variant="standard"
                inputProps={{ maxLength: 255 }}
                InputLabelProps={{
                  style: { color: "#26a69a" },
                }}
                sx={{
                  "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
                    color: "orange",
                  },
                }}
                onChange={(e) => {
                  onChangeOrderNote(e);
                  setCount(255 - e.target.value.length);
                }}
                // onChange={(description) =>
                //   setAddBasemix({
                //     ...addBasemix,
                //     description: description.target.value,
                //   })
                // }
                // value={addBasemix.description}
                fullWidth={true}
              />
            </Col>
          </Row>
          <Row>
            <Col span={23}>
              <p className="text-right">{count}</p>{" "}
            </Col>
          </Row>
          <Row justify="end" style={{ margin: "2rem" }}>
            <Col span={4}>
              {isLoader ? (
                <img src={LoaderGif} height={60} width={60} />
              ) : (
                <Button
                  style={{
                    backgroundColor: "orange ",
                    color: "#fff",
                    width: "100%",
                    fontSize: "12px",
                  }}
                  onClick={() => onSubmitNote()}
                >
                  CONTINUE
                </Button>
              )}
            </Col>
          </Row>
        </CheckoutContainer>
      </Col>
    </Row >
  );
}
export default OrderNoteCard;
